import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const snapshotSchema: Schema = {
  title: 'Snapshot',
  level: 2,
  columns: commonColumns
}
